
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import Icon from 'components/Icon'
import classnames from 'classnames'
import WithTooltip from 'components/WithTooltip'

export default class ConversionIcon extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    group: PropTypes.string,
    active: PropTypes.bool,
    className: PropTypes.string,
    onMouseOver: PropTypes.func,
    onMouseOut: PropTypes.func,
    onClick: PropTypes.func,
    tooltip: PropTypes.string,
    size: PropTypes.string,
    disabled: PropTypes.bool
  }

  static defaultProps = {
    size: '40px'
  }

  render() {
    const {
      name,
      group,
      active,
      className,
      onMouseOver,
      onMouseOut,
      onClick,
      size,
      tooltip,
      disabled
    } = this.props
    const classNames = classnames('conversion-icon', className, {
      [`is-${group}`]: !disabled && group,
      'is-active': !disabled && active,
      'is-disabled': disabled
    })

    return (
      <WithTooltip place='top' title={tooltip}>
        <div
          className={classNames}
          onMouseEnter={onMouseOver}
          onMouseLeave={onMouseOut}
          onClick={onClick}
        >
          <Icon
            className='conversion-icon_icon'
            name={`conversion-${name}`}
            size={size}
          />
        </div>
      </WithTooltip>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/ConversionIcon/index.js